// @flow
/* eslint-disable no-use-before-define */

export type StepType = $Values<typeof STEP_TYPE>
export type StepTypeName = $Keys<typeof STEP_TYPE>

export const STEP_TYPE = {
  WALK: 'walk',
  TRANSIT: 'transit', // NOT SUPPORTED ANYMORE
  PUBLIC_TRANSIT: 'public_transit',
}

export default STEP_TYPE
